import { render, staticRenderFns } from "./TypoLink.vue?vue&type=template&id=23823c3c"
import script from "./TypoLink.vue?vue&type=script&lang=js"
export * from "./TypoLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports